import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "modifiers", "style", "tagType"];
import React from 'react';
import PropTypes from 'prop-types';
const Wrapper = React.forwardRef((_ref, ref) => {
  let {
      children,
      className,
      modifiers,
      style,
      tagType
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const TagType = !tagType || tagType === 'Default' ? 'div' : tagType;
  return children && /*#__PURE__*/React.createElement(TagType, _extends({
    ref: ref,
    className: `${className} ${modifiers}`,
    style: style
  }, props), children);
});
Wrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  modifiers: PropTypes.string,
  style: PropTypes.object,
  tagType: PropTypes.string
};
Wrapper.defaultProps = {
  className: '',
  modifiers: '',
  style: {},
  tagType: ''
};
export default Wrapper;
//# sourceMappingURL=Wrapper.js.map